<template>
  <div class="itemInner">
    <div class="itemInfo">
      <router-link
        :to="{ name: 'amenity', params: { lang: lang }}"
        class="itemInfo">
        <div class="subject">{{locale.amenity}}</div>
      </router-link>
    </div>
    <div class="itemOption">
      <!-- price -->
      <div class="priceInfo notranslate">
        <div class="byQuantity row">
          <div class="item"
            v-for="(option, index) in item.price.option"
            :key="index">
            <div class="label toCapitalize">
              <span class="thumb"><img :src="src(amenityItem)" alt=""></span>
              <span>{{getItemName(option.item)}}</span> ({{option.quantity}})
            </div>
            <div class="value">{{priceFormat(option.price)}}</div>
          </div>
          <div v-if="item.price.info && item.price.info.total !== 0" class="item price">
            <span class="label toCapitalize">{{locale.total}}</span>
            <span class="value">{{priceFormat(item.price.info.total)}}</span>
          </div>
        </div>
      </div>
      <!-- //price -->
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'

export default {
  name: 'PaymentItemAmenity',
  props: [
    'itemData',
    'lang',
    'locale',
    'localeAmenity',
    'noLink'
  ],
  computed: {
    item () {
      const item = this.itemData
      return {
        ...item,
        content: item.content ? item.content.map(x => {
          return {
            ...x,
            value: x.valueOption || x.value
          }
        }) : []
      }
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm:ss'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    itemDatetime () {
      const datetime = this.item.content && this.item.content.find(x => x.type === 'datetime')
      return datetime ? datetime.value : null
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    priceItems () {
      return this.item.items.filter(x => x.price)
    },
    isGuestDiscount () {
      return this.itemData.guestTypePrice && this.itemData.guestTypePrice.normalPrice !== this.itemData.guestTypePrice.total
    }
  },
  data () {
    return {
    }
  },
  methods: {
    src (amenityItem) {
      return `${process.env.BASE_URL}img/amenity/${amenityItem.toLowerCase()}.png`
    },
    datetimeFormat (iso) {
      DateTime.fromISO(iso, { zone: this.timezone })
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    isEmpty (str) {
      return regExp.replaceAllEmpty(str).length <= 0
    },
    getItemName (raCode) {
      const itemName = `amenity_${raCode.toLowerCase()}`
      return this.localeAmenity[itemName]
    }
  }
}
</script>

<style lang="scss" scoped>
.cartItem .priceInfo {
  margin-top: 5px;
}
.cartItem {
  .item {
    margin-bottom: 5px;
  }
  .thumb {
    display: inline-block;
    width: 32px;
    height: 32px;
    padding: 3px;
    vertical-align: middle;
    img {
      position: static;
    }
  }
}
</style>
